import { toUnix } from "@/stories/utils/dates";
import type { VisibleEvent, VisibilityOptions } from "@/types";

export default (data: VisibleEvent, options: VisibilityOptions): boolean => {
  const now = toUnix(new Date());

  // Activity has ended
  if (now > data.endDate) {
    return false;
  }

  let visibilityStartTime: number;

  if (options.visibilityType === "now") {
    return true;
  } else if (options.visibilityType === "onStartTime") {
    // "onStartTime" - visible from start date
    visibilityStartTime = data.startDate;
  } else {
    // "beforeXMinutes" - visible X minutes before start
    // Calculate total minutes from UI components
    const totalMinutes =
      (options.visibleFromDays || 0) * 1440 +
      (options.visibleFromHours || 0) * 60 +
      (options.visibleFromMinutes || 0);
    // Convert minutes to seconds and subtract from start date
    visibilityStartTime = data.startDate - totalMinutes * 60;
  }

  return now >= visibilityStartTime;
};
